import unauthenticatedHttp from "@/services/unauthenticatedHttp";

export async function freeContents() {
  const { data } = await unauthenticatedHttp().get(
    `${window.env.API_UNAUTH}/freeContent`
  );

  return data;
}
